import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { config } from '@/config';

const app = initializeApp(config.firebase);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Connect to emulators in development
if (config.emulators.useEmulators) {
  connectAuthEmulator(auth, `http://${config.emulators.authHost}:${config.emulators.authPort}`, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(db, config.emulators.firestoreHost, config.emulators.firestorePort);
}

export { app };
